export default __webpack_public_path__ + "static/media/spin-bg-14.eeb16f7e.png";